import { CombinedGraphQLErrors } from '@apollo/client';
import { GraphQLErrorCode } from '@insio/validation';

/**
 * Maps a user-management GraphQL error to a `systemSettings.users` translation key.
 * Returns undefined when the error has no known code (caller falls back to the raw message).
 */
export function getUserManagementErrorKey(error: unknown): string | undefined {
  if (!CombinedGraphQLErrors.is(error)) {
    return undefined;
  }

  const lastAdmin = error.errors.some(
    gqlError => gqlError.extensions?.['code'] === GraphQLErrorCode.AT_LEAST_ONE_ADMIN
  );
  return lastAdmin ? 'errors.lastAdmin' : undefined;
}
